module.exports = __webpack_public_path__ + "static/media/arrowDown.b9c7d2c4.svg";